import { Box } from "@mui/material";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Loader from "../../../assets/images/ExplorePage/Loader.svg";
import botagCloseBtn from "../../../assets/images/botagCloseBtn.png";
import LabelIcon from "../../../assets/images/label-icon.svg";
import AppContext from "../../../contexts/AppContext";
import LayoutContext from "../../../contexts/LayoutContext";
import * as Library from "../../../utils/Library";
import logGA4Event from "../../../utils/firebase/analytics";
import { storeImageDetails } from "../../../utils/helperFunctions";
import SearchButton from "./subComponents/SearchButton";

// #region STYLED CSS
const StyledPage = styled.div`
    &.SearchPageContainer {
        position: relative;
        width: 100%;
        flex-shrink: 1;
        padding: 30px 24px 0 24px;
        box-sizing: border-box;
    }
    &.mobile-skeleton {
        padding: 0px 16px 0 16px !important;
    }
    .allfeedLogos {
        display: inline-flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        width: 100%;
        flex-shrink: 0;
        gap: 12px;
        padding-bottom: 14px;
        height: 54px;
    }

    .allfeedLogos::-webkit-scrollbar {
        height: 6px;
    }

    .allfeedLogos .feedIcon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 107px;
        height: 50px;
        border: 2px solid #383838;
        border-radius: 10px;
        font-size: 20px;
        font-weight: 200;
        cursor: pointer;
        padding: 0px 6px;
        flex-shrink: 0;
        position: relative;

        transition: border-color 0.5s;
    }

    .allfeedLogos .feedIcon img {
        width: 100%;
        height: 79%;
        object-fit: contain;
        flex-shrink: 1;
    }

    .allfeedLogos .feedIcon.active {
        border-color: #f7665f;
    }

    .allfeedLogos .feedIcon:hover {
        border-color: #f7665f;
    }

    img.MuiImageListItem-img.sublogoMain {
        height: 42px;
        width: 143px;
        position: absolute;
        bottom: 5px;
        right: 5px;
        padding: 5px 5px 1px 10px;
        object-fit: contain;
    }
    .product-count {
        height: 34px;
        position: absolute;
        bottom: 10px;
        left: 15px;
        width: 116px;
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .image-text {
        display: flex;
        gap: 5px;
        justify-content: space-between;
        align-items: center;
    }
    .product-count-no {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: OpenSans-Regular, sans-serif;
        font-size: 14.4px;
        line-height: 24px;
        font-weight: 400;
    }
    .loading-skeleton {
        display: flex;
        gap: 16px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100px !important;
        height: calc(100dvh - 300px);
    }
    .MasonryContainer {
        overflow: scroll;
        width: 100%;
        height: calc(100dvh - 228px);
    }
    .MasonryContainer.loadingSkeleton {
        height: auto;
    }
    .MasonryContainer::-webkit-scrollbar {
        width: 8px; /* For Chrome, Safari, and Opera */
    }

    .MasonryContainer::-webkit-scrollbar-track {
        background: #000000; /* For Chrome, Safari, and Opera */
        padding-left: 2px; /* Add padding-left */
    }

    .MasonryContainer::-webkit-scrollbar-thumb {
        background-color: #3e3e3e; /* For Chrome, Safari, and Opera */
        border-radius: 10px; /* For Chrome, Safari, and Opera */
    }
    .FeedPageContainer.pad-container {
        padding: 0px !important;
    }
    .feed-image-wrapper {
        display: inline-block;
        position: relative;
        flex-direction: column;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
        gap: 9px;
        display: flex;
        width: 100%;
        height: 100%;
    }
    .feed-image-wrapper-new {
        position: relative;
    }
    img.sublogoMain {
        position: absolute;
        height: 42px;
        width: 143px;
        position: absolute;
        bottom: 5px;
        right: 5px;
        padding: 5px 5px 1px 10px;
        object-fit: contain;
    }
    .feed-image {
        width: 100%;
        object-fit: cover;
        max-height: 100%;
        height: 600px !important;
        //opacity: 0;
        //transform: translateY(20px);
        //transition: opacity 0.5s ease-out, transform 0.5s ease-out;
    }
    .feed-image-wrapper-new-main {
        animation: fadeIn 1s ease-in-out;
    }
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    .spinner-img {
        animation: spin 1s linear infinite;
    }
    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }

    .feed-image-gradient {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40%; /* adjust the height to your liking */
        background: linear-gradient(to right bottom, rgb(0 0 0 / 0%) 0%, rgb(0 0 0 / 0%) 50%, rgb(0 0 0 / 50%) 100%);
    }
    @keyframes pulse-white {
        0% {
            transform: scale(1.2);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);
        }

        100% {
            transform: scale(0.9);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
        }
    }
    .beacons {
        display: flex;
        flex-direction: column;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
        gap: 10px;
        position: absolute;
        user-select: none;
        touch-action: none;
        cursor: pointer;
    }
    .beacon-main-div {
        position: relative;
        background-color: rgba(0, 0, 0, 0.3);
        height: 40px;
        width: 40px;
        border-radius: 50%;
        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
        animation: 1.5s ease 0s infinite normal none running pulse-white;
    }
    .beacon-product-name {
        background-color: rgba(16, 20, 27, 0.3);
        border-radius: 20px;
        color: rgb(255, 255, 255);
        padding: 8px 15px;
        position: absolute;
        top: 45px;
        white-space: nowrap;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    @media only screen and (max-width: 992px) {
        .feed-image {
            height: 563px !important;
        }
    }
`;
// #endregion

export default function SearchPageV2() {
    // #region VARS
    const boxRef = useRef(null);
    const location = useLocation();
    const locationStates = location.state;
    const navigate = useNavigate();
    const { setFeedLogo, setShowBOImagePageID, setShowBOPicpageID } = useContext(LayoutContext);
    const { setSelectedHomePageBotagId, setReplaceCurrentBotMessage } = React.useContext(AppContext);

    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    // ---- PAGE DATA ----
    const [allFeedData, setAllFeedData] = useState([]);
    const [allBrandData, setAllBrandData] = useState([]);

    const defaultFilters = {
        imageFilter: "Posts",
        brandFilter: [],
        genderFilter: "All",
        ageGroupFilter: "All",
        productCategoryFilter: "All",
        productTypeFilter: [],
        colorFilter: [],
        sizeFilter: "All",
        priceRangeFilter: "All",
        deliveryFilter: "All"
    };
    const [filterOptions] = useState({
        imageFilter: [
            { _id: "Posts", name: "Posts" },
            { _id: "Products", name: "Products" }
        ],
        genderFilter: [
            { _id: "All", name: "All" },
            { _id: "Men", name: "Men" },
            { _id: "Women", name: "Women" }
        ],
        ageGroupFilter: [
            { _id: "All", name: "All" },
            { _id: "Babies", name: "Babies (0-2 yo)" },
            { _id: "Toddlers", name: "Toddlers (3-4 yo)" },
            { _id: "Kids", name: "Kids (5-12)" },
            { _id: "Teenagers", name: "Teenagers (13-19 yo)" },
            { _id: "Young Adults", name: "Young Adults (20-35 yo)" }
        ],
        productCategoryFilter: [
            { _id: "All", name: "All" },
            { _id: "Fashion", name: "Fashion" },
            { _id: "Homewear & Deco", name: "Homewear & Deco" },
            { _id: "Kitchenwear", name: "Kitchenwear" }
        ],
        productTypeFilter: [
            { _id: "All", name: "All" },
            { _id: "Jackets & Coats", name: "Jackets & Coats" },
            { _id: "Knitwear", name: "Knitwear" },
            { _id: "Cashmere", name: "Cashmere" },
            { _id: "Dresses & Jumpsuits", name: "Dresses & Jumpsuits" },
            { _id: "Shirts & Blouses", name: "Shirts & Blouses" },
            { _id: "Shorts", name: "Shorts" },
            { _id: "Rainwear", name: "Rainwear" },
            { _id: "Trousers", name: "Trousers" },
            { _id: "Tops & T-shirts", name: "Tops & T-shirts" },
            { _id: "Jeans", name: "Jeans" },
            { _id: "Shorts & Skirts", name: "Shorts & Skirts" },
            { _id: "Loungewear", name: "Loungewear" },
            { _id: "Shirts", name: "Shirts" },
            { _id: "Sweatshirts & Hoodies", name: "Sweatshirts & Hoodies" },
            { _id: "Blazers", name: "Blazers" },
            { _id: "Suiting", name: "Suiting" },
            { _id: "Lingerie", name: "Lingerie" },
            { _id: "Jeans", name: "Jeans" },
            { _id: "Casual", name: "Casual" },
            { _id: "Party", name: "Party" }
        ],
        colorFilter: [
            { _id: "All", name: "All" },
            { _id: "Red", name: "Red" },
            { _id: "Green", name: "Green" },
            { _id: "Blue", name: "Blue" },
            { _id: "Yellow", name: "Yellow" },
            { _id: "Cyan", name: "Cyan" },
            { _id: "Magenta", name: "Magenta" },
            { _id: "Orange", name: "Orange" },
            { _id: "Purple", name: "Purple" },
            { _id: "Pink", name: "Pink" },
            { _id: "Brown", name: "Brown" },
            { _id: "Black", name: "Black" },
            { _id: "White", name: "White" }
        ],
        deliveryFilter: [
            { _id: "All", name: "All" },
            { _id: "Pick-up in store", name: "Pick-up in store" },
            { _id: "Courier now to your location", name: "Courier now to your location" },
            { _id: "Shipping to an address", name: "Shipping to an address" }
        ],
        priceRangeFilter: [{ _id: "All", name: "All" }]
    });

    const [currentFilters, setCurrentFilters] = useState(undefined);
    // #endregion

    // #region METHODS
    const convertColorNameToRGB = colorName => {
        switch (colorName?.toLowerCase()) {
            case "red":
                return { red: 255, green: 0, blue: 0 };
            case "green":
                return { red: 0, green: 255, blue: 0 };
            case "blue":
                return { red: 0, green: 0, blue: 255 };
            case "yellow":
                return { red: 255, green: 255, blue: 0 };
            case "cyan":
                return { red: 0, green: 255, blue: 255 };
            case "magenta":
                return { red: 255, green: 0, blue: 255 };
            case "orange":
                return { red: 255, green: 165, blue: 0 };
            case "purple":
                return { red: 128, green: 0, blue: 128 };
            case "pink":
                return { red: 255, green: 192, blue: 203 };
            case "brown":
                return { red: 165, green: 42, blue: 42 };
            case "black":
                return { red: 0, green: 0, blue: 0 };
            case "white":
                return { red: 255, green: 255, blue: 255 };
            case "grey":
            case "gray":
                return { red: 128, green: 128, blue: 128 };
            default:
                console.warn(`Color name "${colorName}" not recognized!`);
                return undefined;
        }
    };

    const loadFiltersFromLocationStates = locationStates => {
        const { posts_or_products, brands, gender, age_groups, product_types, colors, sizes, delivery_method, price_min, price_max } =
            locationStates;

        let brandsArray = brands?.map(brand => {
            return { _id: brand?._id, name: brand?.name };
        });
        let colorsArray = colors?.map(color => {
            return { _id: color, name: color };
        });
        let productTypesArray = product_types?.map(pt => {
            return { _id: pt, name: pt };
        });

        if (!brandsArray || brandsArray?.length === 0) brandsArray = [{ _id: "All", name: "All" }];
        if (!colorsArray || colorsArray?.length === 0) colorsArray = [{ _id: "All", name: "All" }];
        if (!productTypesArray || productTypesArray?.length === 0) productTypesArray = [{ _id: "All", name: "All" }];
        const imageFilter = posts_or_products === "Products" || posts_or_products === "products" ? "Products" : "Posts";

        // if (price_min && price_max) => "${price_min}-${price_max}" else if (price_min) => "Above ${price_min}" else if (price_max) => "Below ${price_max}" else "All"
        const priceTmp =
            price_min && price_max
                ? `${price_min}-${price_max}`
                : price_min
                ? `Above ${price_min}`
                : price_max
                ? `Below ${price_max}`
                : "All";

        const tmpFilters = {
            imageFilter: imageFilter,
            brandFilter: brandsArray,
            genderFilter: gender || "All",
            ageGroupFilter: age_groups || "All",
            productCategoryFilter: "All", //TODO: to be implemented
            productTypeFilter: productTypesArray,
            colorFilter: colorsArray,
            sizeFilter: sizes || "All",
            priceRangeFilter: priceTmp,
            deliveryFilter: delivery_method || "All"
        };

        setCurrentFilters(tmpFilters);
    };

    const getFilterForRequest = () => {
        //Multiselect filters
        let brandIDs = currentFilters?.brandFilter?.filter(i => i?._id !== "All")?.map(i => i?._id);
        let colorCodes = currentFilters?.colorFilter?.filter(i => i?._id !== "All")?.map(i => i?._id);
        let productTypes = currentFilters?.productTypeFilter?.filter(i => i?._id !== "All")?.map(i => i?._id);
        //Single select filters
        const ageGroups = currentFilters?.ageGroupFilter !== "All" ? currentFilters?.ageGroupFilter : undefined;
        const deliveryTypes = currentFilters?.deliveryFilter !== "All" ? currentFilters?.deliveryFilter : undefined;
        const genders = currentFilters?.genderFilter !== "All" ? currentFilters?.genderFilter : undefined;
        const productCategories = currentFilters?.productCategoryFilter !== "All" ? currentFilters?.productCategoryFilter : undefined;

        if (brandIDs?.length === 0) brandIDs = undefined;
        if (colorCodes?.length === 0) colorCodes = undefined;
        if (productTypes?.length === 0) productTypes = undefined;

        //convert colorCodes using convertColorNameToRGB
        colorCodes = colorCodes?.map(color => convertColorNameToRGB(color))?.filter(i => i !== undefined);

        return {
            brandIDs: brandIDs,
            colorCodes: colorCodes,
            productTypes: productTypes,
            ageGroups: ageGroups,
            deliveryTypes: deliveryTypes,
            genders: genders,
            productCategories: productCategories
        };
    };

    const searchRequest = async ({ page = currentPage, limit }) => {
        const endpoint = currentFilters?.imageFilter === "Posts" ? "getAllBOimages2" : "getAllBOpics2";
        const filtersParams = getFilterForRequest();

        const payload = {
            ...filtersParams,
            page: page || 1,
            limit: limit
        };

        const res = await Library.makeApiRequest({
            endpoint: endpoint,
            data: payload,
            setLoader: setIsLoading
        });

        if (res?.data?.status === 200) {
            const resData = res?.data?.data;

            const shuffledData = resData.data?.sort(() => Math.random() - 0.5); // Shuffle the data
            if (res.data.data.currentPage === 1) {
                setAllFeedData(shuffledData);
            } else {
                const newData = [...allFeedData, ...shuffledData];
                setAllFeedData(newData);
            }

            // verify if length is only one
            const isOnlyOne = res.data.data.currentPage === 1 && res.data.data.totalCount === 1;

            if (isOnlyOne) {
                const ourID = res.data.data?.data?.[0]?.ourID;
                const firstGtin = res.data.data?.data?.[0]?.BOtags[0].GTINbarcode;
                const selectedType = currentFilters?.imageFilter;

                const timeStamp = new Date().toISOString();
                storeImageDetails(ourID, timeStamp);
                setFeedLogo(false);

                if (selectedType === "Posts") {
                    console.log("First GTIN: ", firstGtin);
                    //setSelectedHomePageBotagId(firstGtin);
                    //setShowBOImagePageID(false);
                    //setSelectedHomePageBotagId(firstGtin);
                    setShowBOPicpageID(false);
                    navigate(`/${ourID}`);
                } else {
                    setSelectedHomePageBotagId(false);
                    setShowBOPicpageID(ourID);
                    //setShowBOImagePageID(false);
                    navigate(`/pic/${ourID}`);
                }

                setReplaceCurrentBotMessage("Only one result found. Redirecting you to the details page.");
                return;
            }

            logGA4Event("Feed_Shown");

            const allOption = { _id: "All", name: "All" };
            setAllBrandData([allOption, ...resData?.brandData]);
            setCurrentPage(page);
        }
    };

    const onGenericFilterSelected = (options, filterName) => {
        const isAllSelected = options?.findIndex(i => i?.name === "All") > -1;

        setCurrentFilters(prev => ({
            ...prev,
            [filterName]: isAllSelected ? [{ name: "All", _id: "All" }] : options
        }));
    };

    const onOptionFilterSelected = (option, filterName) => {
        const name = option?.name;

        setCurrentFilters({
            ...currentFilters,
            [filterName]: name
        });
    };
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        if (!currentFilters) return;
        searchRequest({ page: 1, limit: 12 });
    }, [currentFilters]); // Search when filters change

    useEffect(() => {
        const states = locationStates || {};
        loadFiltersFromLocationStates(states);
    }, [locationStates]); // Load filters from location state on mount
    // #endregion

    // #region RENDER
    return (
        <StyledPage className="SearchPageContainer w-100">
            <div className="flex justify-center w-100 gap-8px flex-wrap">
                <SearchButton
                    className=""
                    title="Images"
                    options={filterOptions?.imageFilter}
                    value={currentFilters?.imageFilter}
                    onOptionSelected={option => onOptionFilterSelected(option, "imageFilter")}
                    selectedValue={currentFilters?.imageFilter}
                    isActive={true}
                />
                <SearchButton
                    className="flex-shrink-0"
                    title="Brand"
                    options={allBrandData}
                    onOptionSelected={options => onGenericFilterSelected(options, "brandFilter")}
                    isActive={currentFilters?.brandFilter[0]?.name !== "All"}
                    useSearch={true}
                    isMultiSelect={true}
                    selectedValues={currentFilters?.brandFilter}
                />
                <SearchButton
                    className="flex-shrink-0"
                    title="Gender"
                    options={filterOptions?.genderFilter}
                    onOptionSelected={option => onOptionFilterSelected(option, "genderFilter")}
                    selectedValue={currentFilters?.genderFilter}
                    isActive={currentFilters?.genderFilter !== defaultFilters?.genderFilter}
                />
                <SearchButton
                    className="flex-shrink-0"
                    title="Age Group"
                    options={filterOptions?.ageGroupFilter}
                    onOptionSelected={option => onOptionFilterSelected(option, "ageGroupFilter")}
                    selectedValue={currentFilters?.ageGroupFilter}
                    isActive={currentFilters?.ageGroupFilter !== defaultFilters?.ageGroupFilter}
                />
                <SearchButton
                    className="flex-shrink-0"
                    title="Product Category"
                    options={filterOptions?.productCategoryFilter}
                    onOptionSelected={option => onOptionFilterSelected(option, "productCategoryFilter")}
                    selectedValue={currentFilters?.productCategoryFilter}
                    isActive={currentFilters?.productCategoryFilter !== defaultFilters?.productCategoryFilter}
                />
                <SearchButton
                    className="flex-shrink-0"
                    title="Product Type"
                    options={filterOptions?.productTypeFilter}
                    onOptionSelected={options => onGenericFilterSelected(options, "productTypeFilter")}
                    isActive={currentFilters?.productTypeFilter[0]?.name !== "All"}
                    useSearch={false}
                    isMultiSelect={true}
                    selectedValues={currentFilters?.productTypeFilter}
                />
                <SearchButton
                    className="flex-shrink-0"
                    title="Color"
                    options={filterOptions?.colorFilter}
                    onOptionSelected={options => onGenericFilterSelected(options, "colorFilter")}
                    isActive={currentFilters?.colorFilter[0]?.name !== "All"}
                    useSearch={false}
                    isMultiSelect={true}
                    selectedValues={currentFilters?.colorFilter}
                />
                <SearchButton
                    className="flex-shrink-0"
                    title="Size"
                    options={filterOptions?.sizeFilter}
                    onOptionSelected={option => onOptionFilterSelected(option, "sizeFilter")}
                    selectedValue={currentFilters?.sizeFilter}
                    isActive={currentFilters?.sizeFilter !== defaultFilters?.sizeFilter}
                />
                <SearchButton
                    className="flex-shrink-0"
                    title="Price Range"
                    options={filterOptions?.priceRangeFilter}
                    onOptionSelected={option => onOptionFilterSelected(option, "priceRangeFilter")}
                    selectedValue={currentFilters?.priceRangeFilter}
                    isActive={currentFilters?.priceRangeFilter !== defaultFilters?.priceRangeFilter}
                />
                <SearchButton
                    className="flex-shrink-0"
                    title="Delivery"
                    options={filterOptions?.deliveryFilter}
                    onOptionSelected={option => onOptionFilterSelected(option, "deliveryFilter")}
                    selectedValue={currentFilters?.deliveryFilter}
                    isActive={currentFilters?.deliveryFilter !== defaultFilters?.deliveryFilter}
                />
            </div>

            <div className="flex w-100" style={{ marginTop: "30px" }}>
                <MasonryImageList
                    boxRef={boxRef}
                    allFeedData={allFeedData}
                    skeletonLoading={isLoading}
                    selectedType={currentFilters?.imageFilter}

                    //setFeedLogo={setFeedLogo}
                    //targetImageRef={targetImageRef}
                    //setBeacon={setBeacon}
                    //beacon={beacon}
                    //setSelectedHomePageBotagId={setSelectedHomePageBotagId}
                    //setOnHover={setOnHover}
                    //isShowCloseBtn={isShowCloseBtn}
                    //setIsShowCloseBtn={setIsShowCloseBtn}
                />
            </div>
        </StyledPage>
    );
    // #endregion
}

// #region SUB COMPONENTS
const MasonryImageList = ({ allFeedData, boxRef, skeletonLoading, selectedType }) => {
    // #region VARS
    const { isMobile, setFeedLogo, setShowBOImagePageID, setShowBOPicpageID, windowWidth: width } = useContext(LayoutContext);
    const { setSelectedHomePageBotagId } = React.useContext(AppContext);
    const navigate = useNavigate();

    const targetImageRef = useRef([]);

    const [isShowCloseBtn, setIsShowCloseBtn] = useState({ state: false, id: "" });
    const [beacon, setBeacon] = useState({ state: false, id: "" });
    // #endregion

    // #region METHODS
    //TODO: REVIEW THIS AND MAKE IT AUTOMATIC BASED ON SCREEN SIZE
    const calculateMasonryCols = () => {
        if (width < 600) return 1;
        else if (width <= 1000) return 2;
        else if (width < 1280) return 3;
        else if (width <= 1850) return 4;
        else if (width <= 1920) return 5;
        else return Math.floor((width * 4) / 1920);
    };

    const handleImageLoad = index => {
        if (targetImageRef.current[index] && targetImageRef.current[index].current) {
            targetImageRef.current[index].current.classList.add("visible");
        }
    };
    // #endregion

    // #region RENDER
    return (
        <Box className={`MasonryContainer main-masonry ${skeletonLoading ? "loadingSkeleton" : ""}`} ref={boxRef}>
            {skeletonLoading ? (
                <div className="loading-skeleton">
                    <img src={Loader} alt="" className="spinner-img" />
                    <div style={{ fontSize: "16px", fontWeight: 600, color: "rgba(255, 255, 255, 1)" }}>Loading please wait...</div>
                </div>
            ) : (
                <ImageList
                    variant="standard"
                    cols={calculateMasonryCols()}
                    style={{ marginTop: "0", gap: "5px", display: skeletonLoading ? "none" : "" }}>
                    {allFeedData.map((item, index) => {
                        if (!targetImageRef.current[index]) {
                            targetImageRef.current[index] = React.createRef();
                        }
                        return (
                            <ImageListItem
                                key={item?.ourID}
                                style={{ cursor: "pointer" }}
                                className="feed-image-wrapper-new-main"
                                onMouseEnter={() => {
                                    !isMobile &&
                                        setBeacon({
                                            state: true,
                                            id: item?.ourID
                                        });
                                }}
                                onMouseLeave={() => {
                                    !isMobile &&
                                        setBeacon({
                                            state: false,
                                            id: item?.ourID
                                        });
                                }}
                                onClick={() => {
                                    const timeStamp = new Date().toISOString();
                                    storeImageDetails(item?.ourID, timeStamp);
                                    setFeedLogo(false);
                                    setSelectedHomePageBotagId(false);

                                    if (selectedType === "Posts") {
                                        setShowBOImagePageID(item?.ourID);
                                        setShowBOPicpageID(false);
                                        navigate(`/${item?.ourID}`);
                                    } else {
                                        setShowBOPicpageID(item?.ourID);
                                        setShowBOImagePageID(false);
                                        navigate(`/pic/${item?.ourID}`);
                                    }

                                    setIsShowCloseBtn({ state: false, id: "" });
                                }}>
                                <div className="feed-image-wrapper">
                                    <img
                                        src={`${item?.imageURL}`}
                                        srcSet={`${item?.imageURL}`}
                                        alt={item?.labelBrandID}
                                        loading="lazy"
                                        style={{ minHeight: "200px", borderRadius: "0px" }}
                                        className="feed-image"
                                        ref={targetImageRef.current[index]}
                                        onLoad={() => handleImageLoad(index)}
                                    />
                                    {beacon?.state &&
                                        beacon?.id === item?.ourID &&
                                        item?.BOtags?.map(i => {
                                            return (
                                                <Beacon
                                                    key={beacon?.id + i?.GTINbarcode}
                                                    i={i}
                                                    item={item}
                                                    targetImageRef={targetImageRef.current[index]}
                                                    setSelectedHomePageBotagId={setSelectedHomePageBotagId}
                                                    setIsShowCloseBtn={setIsShowCloseBtn}
                                                    selectedType={selectedType}
                                                    setShowBOPicpageID={setShowBOPicpageID}
                                                />
                                            );
                                        })}
                                    <div className="feed-image-gradient" />
                                </div>
                                {isMobile && isShowCloseBtn?.state && isShowCloseBtn?.id === item?.ourID && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            zIndex: 5,
                                            top: "25px",
                                            left: "25px"
                                        }}
                                        onClick={e => {
                                            e.stopPropagation();
                                            setBeacon({
                                                state: false,
                                                id: ""
                                            });

                                            setIsShowCloseBtn(false);
                                        }}>
                                        <img src={botagCloseBtn} alt="" height={"50px"} width={"50px"} />
                                    </div>
                                )}
                                {!isShowCloseBtn?.state && (
                                    <div
                                        className="product-count"
                                        onClick={e => {
                                            e.stopPropagation();
                                            if (isMobile) {
                                                setBeacon({
                                                    state: true,
                                                    id: item?.ourID
                                                });

                                                setIsShowCloseBtn({ state: true, id: item?.ourID });
                                            } else {
                                                setShowBOImagePageID(item?.ourID);
                                            }
                                        }}>
                                        <div className="image-text">
                                            <img src={LabelIcon} alt="" />
                                            <span className="product-count-no">{`${item?.BOtags?.length ?? 0} products`}</span>
                                        </div>
                                    </div>
                                )}
                                <img className="sublogoMain" src={item?.brandLogo} alt="" />
                            </ImageListItem>
                        );
                    })}
                </ImageList>
            )}
        </Box>
    );
    // #endregion
};

const Beacon = ({ i, item, targetImageRef, setSelectedHomePageBotagId, setIsShowCloseBtn, selectedType, setShowBOPicpageID }) => {
    // #region VARS
    const navigate = useNavigate();
    const { setShowRightUserLocationPanel, setShowBOImagePageID } = React.useContext(LayoutContext);
    // #endregion

    // #region METHODS
    const handleBOImagePin = botag => {
        setShowRightUserLocationPanel(true);
        setSelectedHomePageBotagId(botag?.GTINbarcode);
        if (selectedType === "Posts") {
            navigate(`/${item?.ourID}`);

            setShowBOPicpageID(false);
        } else {
            setShowBOPicpageID(item?.ourID);
            setShowBOImagePageID(false);
            setShowRightUserLocationPanel(false);
            navigate(`/pic/${item?.ourID}`, { replace: true });
        }

        setIsShowCloseBtn({ state: false, id: "" });
    };
    // #endregion

    // #region RENDER
    return (
        <div
            className="beacons"
            style={{
                left: i?.beaconXposition * (targetImageRef?.current?.clientWidth / targetImageRef?.current?.naturalWidth) - 20 + "px",
                top: i?.beaconYposition * (targetImageRef?.current?.clientHeight / targetImageRef?.current?.naturalHeight) - 15 + "px"
            }}
            onClick={e => {
                handleBOImagePin(i);
                navigate(`/${item?.ourID}`);
                e.stopPropagation();
            }}>
            <div className="beacon-main-div">
                <div
                    style={{
                        backgroundColor: "#FFFFFF",
                        height: "20px",
                        width: "20px",
                        borderRadius: "50%"
                    }}></div>
            </div>
            {i?.productType && <div className="beacon-product-name">{i?.productType}</div>}
        </div>
    );
    // #endregion
};
// #endregion
